import { WalletConnection } from 'near-api-js'
import { EventEmitter } from 'events'

//const fs = require('fs');
//const BN = require('bn.js')
import * as nearAPI from 'near-api-js'
import getConfig from '../near.service.config'
import Vue from 'vue'

Vue.filter('charity', function(index) {
    switch (index) {
        case 0: return "susan-g-komen";
        case 1: return "breast-cancer-research";
        case 2: return "young-survival-coalition";
    }
});

const { NODE_ENV, VUE_APP_NEAR_NFT_CONTRACT_ID, VUE_APP_NEAR_WISHLIST_CONTRACT_ID } = process.env;
const { connect, utils } = nearAPI
const testnetConfig = getConfig('testnet');
const mainnetConfig = getConfig('mainnet');

const configPerContractId = contractId => contractId === VUE_APP_NEAR_NFT_CONTRACT_ID ? testnetConfig : NODE_ENV === 'production' ? mainnetConfig : testnetConfig;
class NearService extends EventEmitter {
    constructor(Vue) {
        super()
        this.Vue = Vue
        this.$store = Vue.prototype.$store
        this.connecting = {}
        this.contract = {}
        this.wallet = {}
        this.near = {}
        Array(VUE_APP_NEAR_NFT_CONTRACT_ID, VUE_APP_NEAR_WISHLIST_CONTRACT_ID).forEach(contractId => {
            this.connecting[contractId] = connect({
                keyStore: new nearAPI.keyStores.BrowserLocalStorageKeyStore(),
                ...configPerContractId(contractId)
            }).then((near) => (this.near[contractId] = near));
        })
        this.signIn = this.signIn.bind(this)
        this.signOut = this.signOut.bind(this)
        this.purchase = this.purchase.bind(this)
        this.parseUsername = this.parseUsername.bind(this)
        this.parseNearAccountId = this.parseNearAccountId.bind(this)
        this.ipfsCompatible = false;
    }
    async getWalletConnection(contractId = VUE_APP_NEAR_NFT_CONTRACT_ID) {
        await this.connecting[contractId]
        this.wallet[contractId] = await this.wallet[contractId] ? this.wallet[contractId] : new WalletConnection(this.near[contractId], 'BraNFT™ Bra NFTs');
        return this.wallet[contractId];
    }
    async loadContract(contract) {
        const wallet = await this.getWalletConnection(contract)
        const config = configPerContractId(contract)
        this.contract[contract] =
            this.contract[contract] ||
            new nearAPI.Contract(wallet.account(), config.contracts[contract], {
                ...config.contracts[contract],
                sender: wallet.account(),
            })
        return this.contract[contract]
    }
    async signOut(options) {
        const { contractIds } = options;
        const contractIdArray = contractIds && contractIds.length ? contractIds : [VUE_APP_NEAR_NFT_CONTRACT_ID, VUE_APP_NEAR_WISHLIST_CONTRACT_ID]
        
        contractIdArray.forEach(contractId => {
            if (!this.wallet[contractId]) return
            this.wallet[contractId].signOut();
            delete this.wallet[contractId];
        });
    }
    async signIn(options = { contractId: VUE_APP_NEAR_NFT_CONTRACT_ID }) {
        const config = configPerContractId(options.contractId);
        const { walletSigninArgs } = options;
        if (NODE_ENV !== 'production') console.log({config})
        const defaultSigninArgs = {
            contractId: options.contractId,
            title: 'BraNFT™ Bra NFTs',
        }
        const wallet = await this.getWalletConnection(options.contractId);
        await wallet.requestSignIn({
            ...walletSigninArgs,
            ...defaultSigninArgs,
        });
        return wallet;
    }
    async getNftMetadata(tokenId) {
        try {
            const contract = await this.loadContract(VUE_APP_NEAR_NFT_CONTRACT_ID)
            const response = await contract.nft_token({ token_id: tokenId })
            return response ? response.metadata : undefined
        } catch (error) {
            console.log(error)
        }
    }
    async mint(contractArgs, reset) {
        if (reset) self.$store.commit('resetCreationState')
        else self.$store.commit({ type: 'set', creationState: { func: 'mint', params: { ...contractArgs } } })
        await this._callContract({
            functionName: 'nft_mint',
            contractArgs,
            depositAmount: nearAPI.utils.format.parseNearAmount('0.1'),
        })
    }
    async updatePrice(tokenOwner, tokenId, price) {
        const self = this
        const wallet = await self.getWalletConnection()
        if (!wallet.isSignedIn()) {
            await self.signIn();
        }
        if (wallet.isSignedIn() && wallet.getAccountId() !== tokenOwner) {
            wallet.signOut()
            await self.updatePrice(tokenOwner, tokenId, price)
            //throw new Error('Only the token owner can change the price.');
        }
        const config = configPerContractId(VUE_APP_NEAR_NFT_CONTRACT_ID);
        const contract = new nearAPI.Contract(
            wallet.account(), // the account object that is connecting
            VUE_APP_NEAR_NFT_CONTRACT_ID,
            {
                ...config.contracts[VUE_APP_NEAR_NFT_CONTRACT_ID],
                sender: wallet.account(), // account object to initialize and sign transactions.
            }
        )
        await callContract()
        async function callContract(retry = 0) {
            try {
                await contract.nft_update_price({
                    args: {
                        token_id: tokenId,
                        price: nearAPI.utils.format.parseNearAmount(price),
                    },
                    amount: nearAPI.utils.format.parseNearAmount('0.1'),
                })
            } catch (error) {
                console.log(error)
                retry
            }
        }
    }
    async commission(params, reset) {
        const self = this
        if (reset) {
            self.$store.commit('resetCommissionState')
            return
        }
        self.$store.commit({ type: 'set', commissionState: { params } })
        const { bid, network, username, walletSigninArgs } = params
        const contractArgs = {
            social_network: network,
            social_username: username,
        }

        await this._callContract({
            functionName: 'commission_bid',
            contractArgs,
            depositAmount: nearAPI.utils.format.parseNearAmount(`${bid}`),
            walletSigninArgs,
        })
    }
    async commissionBidsForUser(params) {
        const { network, username } = params
        const contractArgs = {
            social_network: network,
            social_username: username,
        }
        try {
            const commissions = await this._callContract({
                functionName: 'commission_bids_for_social_id',
                contractArgs,
            })
            console.log(JSON.stringify(commissions, null, 2))
            return commissions
        } catch (error) {
            console.error(error)
        }
    }
    async commissionBidsCount() {
        try {
            const count = await this._callContract({
                functionName: 'commission_bids_total',
            })
            return count
        } catch (error) {
            console.error(error)
        }
    }
    async commissionBids(params = { index: 0, limit: 25 }) {
        const { index, limit } = params
        const contractArgs = {
            index,
            limit,
        }
        try {
            const commissions = await this._callContract({
                functionName: 'commission_bids',
                contractArgs,
            })
            return commissions
        } catch (error) {
            console.error(error)
            return error
        }
    }
    async wishlist(params) {
        return this._callContract({
            contractId: VUE_APP_NEAR_WISHLIST_CONTRACT_ID,
            walletSigninArgs: {
                contractId: VUE_APP_NEAR_WISHLIST_CONTRACT_ID
            },
            ...params })
    }
    async _callContract(params, retry = 0) {
        const self = this
        const { contractId = VUE_APP_NEAR_NFT_CONTRACT_ID, functionName, tokenOwner, contractArgs, depositAmount, gas = '300000000000000', walletSigninArgs, loginRedirect } = params
        const config = configPerContractId(contractId);
        this.loadContract(contractId)
        const wallet = await self.getWalletConnection(contractId)
        
        //if (!wallet.isSignedIn() && !loginRedirect) throw new Error('Not connected to NEAR.')
        if (!wallet.isSignedIn() && loginRedirect) {
            await self.signIn(walletSigninArgs);
            if (retry < 1) return this._callContract(params, ++retry)
        }
        if (functionName.match(/nft_purchase/) && wallet.isSignedIn() && tokenOwner && wallet.getAccountId() !== tokenOwner) {
            wallet.signOut()
            await self._callContract(params, ++retry)
        }
        const contract = {
            [contractId]: new nearAPI.Contract(wallet.account(), contractId, {
                ...config.contracts[contractId],
                sender: wallet.account(),
            })
        }
        async function callContract(retry = 0) {
            try {
                const response = await contract[contractId][functionName](
                    {
                        ...contractArgs,
                    },
                    gas,
                    depositAmount
                )
                // console.log({response})
                response
            } catch (error) {
                console.log(error)
                retry
                throw error
            }
        }
        async function viewContract(retry = 0) {
            try {
                const result = await contract[contractId][functionName]({
                    ...contractArgs,
                })
                return result
            } catch (error) {
                console.log(error)
                retry
                throw error
            }
        }
        return config.contracts[contractId].changeMethods.includes(functionName) ? callContract() : viewContract()
    }
    async purchase(tokenId, purchaseAmount) {
        await this._callContract({
            functionName: 'offer',
            depositAmount: purchaseAmount,
            contractArgs: {
                nft_contract_id: config.contractId['default'],
                token_id: tokenId,
            },
        })
    }
    explorerUrl({ contractId, path = '' }) {
        const config = configPerContractId(contractId);
        const { networkId } = config;
        return `${config[networkId].explorerUrl}${path}`;
    }
    explorerTransactionLink($route, { showUrl = false, contractId = VUE_APP_NEAR_NFT_CONTRACT_ID }) {
        const config = configPerContractId(contractId);
        const { networkId } = config;
        const explorerUrl = `${config[networkId].explorerUrl}/transactions/${$route.query.transactionHashes}`;
        const html = `<a class="font-italic" style="text-decoration: none; overflow-wrap: anywhere" target="_blank" rel="noopener" href="${explorerUrl}">NEAR Explorer</a>`;
        return showUrl ? html.replace('</a>', `<br/><span class="text-caption text-italics">${explorerUrl}</span></a>`) : html;
    }
    convertToUSD(nearAmount) {
        if (!nearAmount || !this.$store.state.lastNearListing) return
        const usdConversion = this.$store.state.lastNearListing.averageUSD;
        return Number.parseFloat(nearAmount * usdConversion).toFixed(2)
    }
    uniqueId(wishlistId, itemId) {
        return {
            wishlist_id: wishlistId,
            item_id: itemId,
        };
    }
    /** this function is also found in strap backend and should be kept in sync */
    parseNearAccountId(username) {
        const { first, last, nickname } = this.parseUsername(username);
        const nearAccountId = `${first}_${nickname.replace(' ', '-')}_${last}.${process.env.VUE_APP_NEAR_MASTER_ACCOUNT}`;
        return nearAccountId;
    }
    /** this function is also found in strap backend and should be kept in sync */
    parseUsername(name) {
        const username = name
            .trim()
            .match(/([a-z0-9-_]*)\s+\(([a-z0-9-_\s]*)\)\s+([a-z0-9-_]*)/i);
        if (!username) return this.parseUsername('Shizuka (Empty Cups) Marikawa');
        const raw = name;
        const first = username[1];
        const firstPlural = username[1].endsWith('s') || username[1].endsWith('S') ? `${username[1]}'` : `${username[1]}'s`;
        const lastPlural = username[3].endsWith('s') || username[3].endsWith('S') ? `${username[3]}'` : `${username[3]}'s`;
        const plural = username[3].endsWith('s') || username[3].endsWith('S') ? `${raw}'` : `${raw}'s`;
        const firstLastPlural = `${first} ${lastPlural}`
        const last = username[3];
        const nickname = username[2].trim().replaceAll(/\s+/g, ' ');
        return { raw, first, plural, firstPlural, lastPlural, firstLastPlural, last, nickname };
    }
    ipfsAdapter(media) {
        if (media.url) media = [media]
        if (!media?.length || !media[0].url) {
            return
        }
        let src = media[0].url;
        if (this.ipfsCompatible) return src;
        const cid = src.match(/ipfs:\/\/(.*)/);
        if (!cid) return src;
        if (this.ipfsCompatible === false)
            return `https://${cid[1]}.ipfs.nftstorage.link/`;
        try {
            fetch(src)
                .then(() => {
                    this.ipfsCompatible = true;
                })
                .catch(() => {
                    this.ipfsCompatible = false;
                    return `https://${cid[1]}.ipfs.nftstorage.link/`;
                });
        } catch (error) {
            this.ipfsCompatible = false;
            return `https://${cid[1]}.ipfs.nftstorage.link/`;
        }
    }
}

export default (Vue) => {
    const near = new NearService(Vue)
    global.near = near
    near.utils = utils
    near.configPerContractId = configPerContractId
    return near
}
